/** Mirrors the BFF's error envelope (bff/src/http/errorEnvelope.ts). Every
 *  non-2xx from /bff/* — and every error the Go API returns through the
 *  proxy — has this shape, which is why the client can unwrap it in one
 *  place instead of each caller guessing. */
export interface ErrorEnvelope {
  readonly data: null
  readonly meta: { readonly request_id: string | null; readonly timestamp: string }
  readonly error: { readonly code: string; readonly message: string }
}

export interface SessionUser {
  readonly sub: string
  readonly name: string
  readonly email: string
  readonly roles: readonly string[]
  readonly billerId: string | null
  readonly isInternal: boolean
}

export type Me =
  | { readonly authenticated: false }
  | { readonly authenticated: true; readonly user: SessionUser; readonly csrfToken: string }

/** GET /bff/config — the SPA's runtime configuration. Deliberately not a
 *  build-time constant: the same image runs in dev, staging and prod. */
export interface RuntimeConfig {
  readonly apiBase: string
  readonly defaultLocale: string
  readonly supportedLocales: readonly string[]
  readonly businessTimezone: string
  readonly currency: string
}

/** Roles as the realm defines them (bff/src/auth/claims.ts). */
export const ROLE_INTERNAL = 'internal'
export const ROLE_BILLER_USER = 'biller-user'
